/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next';

import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

import OfferSignatures from '../../signatures/offerSignatures.json';
import { updateRobotMetaNames } from '@marriott/mi-offers-components';
import { envVarKeys } from '../../_constants/envVarKeys';

function pageRenderer(props) {
  console.log('[offers.tsx] props ', props);
  if (
    props.productSpecificResponse === undefined &&
    props?.query?.invalidDealMsg === 'true' &&
    props.model?.metaNames
  ) {
    const mappedMetaNames = updateRobotMetaNames(props.model.metaNames);
    props.model['metaNames'] = mappedMetaNames;
  }
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const offersSpecificData = async () => {
  // Feature flag call for MBOP
  const featureFlags = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_MBOP, {
    target: TARGETS.APP.OFFERS_RENDERER,
  });

  return {
    operationSignatures: OfferSignatures,
    nextPublicEnvKeys: [...Object.keys(envVarKeys)],
    featureFlags: { featureFlags },
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(offersSpecificData);
export default pageRenderer;
